'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardSelection = exports.CardSelectionUnwrapped = exports.mapStateToProps = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _device = require('redux/modules/device');

var _verify = require('helpers/verify');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The CardSelection component implements common logic for selecting from a collection of Cards
 * on desktop and mobile.
 *
 * CardSelection accepts two types of children: an array of render functions, or an object mapping
 * keys to render functions. The render function should return a node when invoked.
 * Invalid React elements will be filtered out. The renderFunction is invoked with:
 *
 *   renderFunction({
 *     handleSelection: function, // should be invoked when the card is selected (usually onClick).
 *     selected: boolean,         // true if the card was selected most recently, false otherwise.
 *   })
 *
 * On desktop, calling `handleSelection` invokes `onCardSelected` with the key of the card.
 *
 * On mobile, a CTA is rendered. `handleSelection` invocations persist the key of the card in state,
 * flagging the card as selected. When the CTA is clicked, `onCardSelected` is invoked with the key of
 * the flagged card.
 *
 *
 * Example:
 *
 * Object with render functions:
 *
 *   <CardSelection
 *     onCardSelected={key => console.log(key)} // "foo" or "bar"
 *   >
 *     {{
 *       foo: ({ selected, handleSelection }) => <Card onClick={handleSelection} selected={selected} />,
 *       bar: ({ selected, handleSelection }) => <Card onClick={handleSelection} selected={selected} />
 *     }}
 *   </CardSelection>
 *
 * Array with render functions:
 *
 *   <CardSelection
 *     onCardSelected={key => console.log(key)} // 0 or 1
 *   >
 *     {[
 *       ({ selected, handleSelection }) => <Card onClick={handleSelection} selected={selected} />,
 *       ({ selected, handleSelection }) => <Card onClick={handleSelection} selected={selected} />
 *     ]}
 *   </CardSelection>
 */

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    isMobile: (0, _device.selectIsMobile)(state)
  };
};

var CardSelectionUnwrapped = exports.CardSelectionUnwrapped = function (_Component) {
  (0, _inherits3.default)(CardSelectionUnwrapped, _Component);

  function CardSelectionUnwrapped(props) {
    (0, _classCallCheck3.default)(this, CardSelectionUnwrapped);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (CardSelectionUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(CardSelectionUnwrapped)).call(this, props));

    _this2.state = {
      selected: _this2.props.defaultSelected || null
    };

    _this2.handleCtaClick = _this2.handleCtaClick.bind(_this2);
    return _this2;
  }

  (0, _createClass3.default)(CardSelectionUnwrapped, [{
    key: 'handleSelection',
    value: function handleSelection(key) {
      var _props = this.props,
          isMobile = _props.isMobile,
          onCardSelected = _props.onCardSelected;


      if (isMobile) {
        this.setState({ selected: key });
      } else {
        onCardSelected(key);
      }
    }
  }, {
    key: 'handleCtaClick',
    value: function handleCtaClick() {
      var selected = this.state.selected;


      if ((0, _verify.isPresent)(selected)) {
        this.props.onCardSelected(selected);
      }
    }
  }, {
    key: 'renderCards',
    value: function renderCards() {
      var _this = this;

      var children = this.props.children;


      return (0, _keys2.default)(children || []).map(function (key) {
        return children[key]({
          handleSelection: _this.handleSelection.bind(_this, key),
          selected: _this.state.selected === key
        });
      }).filter(_react2.default.isValidElement);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          isMobile = _props2.isMobile,
          mobileCtaCopy = _props2.mobileCtaCopy;

      var renderedCards = this.renderCards();

      return !(0, _verify.isEmpty)(renderedCards) && _react2.default.createElement(
        'div',
        { className: 'card-selection' },
        _react2.default.createElement(
          'div',
          { className: 'card-selection__cards' },
          renderedCards
        ),
        isMobile && _react2.default.createElement(
          'button',
          {
            className: 'bt bt--primary bt--lg mv+',
            disabled: (0, _verify.isAbsent)(this.state.selected),
            onClick: this.handleCtaClick
          },
          mobileCtaCopy
        )
      );
    }
  }]);
  return CardSelectionUnwrapped;
}(_react.Component);

CardSelectionUnwrapped.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.func), _propTypes2.default.objectOf(_propTypes2.default.func)]),
  defaultSelected: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  isMobile: _propTypes2.default.bool.isRequired,
  mobileCtaCopy: _propTypes2.default.node.isRequired,
  onCardSelected: _propTypes2.default.func.isRequired
};

var CardSelection = exports.CardSelection = (0, _reactRedux.connect)(mapStateToProps)(CardSelectionUnwrapped);